<div class="content">
        <mat-spinner class="spinner" [diameter]="40" *ngIf="!contentReady"></mat-spinner>
        <canvas baseChart [data]="pieChartData" [type]="'pie'" [options]="pieChartOptions" *ngIf="contentReady"></canvas>
        <div class="daterange" *ngIf="contentReady">
                <span>{{'GENERAL.FROM' | translate}} {{start}} {{'GENERAL.TO' | translate}} {{end}}</span>
        </div>
</div>